import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useFeatureList() {
    const { t } = useI18nUtils()
    const tableColumns = [
        { key: '', label: '', sortable: false },
        { key: 'icon', label: 'Icon', sortable: false },
        { key: 'title', label: 'Title', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false }
    ];
    const isFeatureFormSidebarActive = ref(false)
    const featureData = ref(null)
    const Features = ref([])
    const totalFeatures = ref(0)
    const currentPage = ref(1)
    const perPage = ref(10)
    const searchQuery = ref('')
    const statusFilter = ref(null)
    const refFeatureListTable = ref(null)
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const toast = useToast()
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const dataMeta = computed(() => {
        const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
        const to = Math.min(
            totalFeatures.value,
            perPage.value * currentPage.value
        );
        return {
            from,
            to,
            of: totalFeatures.value,
        }
    })

    const updateOrdering = () => {
        const filteredData = Features.value?.filter(item => item !== undefined);

        store.dispatch('app-room/updateFeatureOrdering', filteredData)
    }

    const refetchFeatureData = () => {
        fetchFeatureData();
    }

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchFeatureData()
    })

    const fetchFeatureData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);

        store
            .dispatch('app-room/getFeatures', {
                limit: perPage.value,
                offset:offset,
                keywords: searchQuery.value,
                order_by: 'ordering_count DESC',
                sites_id: getLocalSite.id
            })
            .then(response => {
                Features.value = response.data.data
                totalFeatures.value = response.data.total
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: "Error fetching Category' list",
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const resolveFeatureStatusVariant = status => {
        if (status ) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveFeatureStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const updateFeature = (data) => {
        if(typeof(data) === 'object' && data !== null){
            featureData.value = JSON.parse(JSON.stringify(data))
        } else {
            featureData.value = data
        }
        
        isFeatureFormSidebarActive.value = true
    }

    const deleteData = (id) => {
        store.dispatch('app-room/deleteFeature',id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })

            fetchFeatureData();
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Food Category",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    return {
        dataMeta,
        tableColumns,
        isFeatureFormSidebarActive,
        refetchFeatureData,
        fetchFeatureData,
        updateFeature,
        resolveFeatureStatusVariant,
        resolveFeatureStatusnameVariant,
        refFeatureListTable,
        Features,
        sortBy,
        isSortDirDesc,
        totalFeatures,
        featureData,
        deleteData,
        t,
        perPage,
        currentPage,
        searchQuery,
        updateOrdering,
    }
}